import { Injectable, inject } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Country } from '@tradecafe/types/core'
import { DeepReadonly } from '@tradecafe/types/utils'
import { Observable } from 'rxjs'
import {
  DocsCountryConfirmationDialogComponent,
  DocsCountryConfirmationDialogData,
  DocsCountryConfirmationDialogResult
} from './docs-country-confirmation-dialog.component'

@Injectable({ providedIn: 'root' })
export class DocsCountryConfirmationDialogService {
  private dialog = inject(MatDialog)


  showDocsCountryConfirmation(
    defaultDocsCountryCode: string,
    countries: DeepReadonly<Country[]>,
    options?: { message?: string; buyerId?: string }
  ): Observable<DocsCountryConfirmationDialogResult | undefined> {
    const data: DocsCountryConfirmationDialogData = {
      defaultDocsCountryCode,
      countries,
      message: options?.message,
      buyerId: options?.buyerId,
    }

    const dialogRef = this.dialog.open<
      DocsCountryConfirmationDialogComponent,
      DocsCountryConfirmationDialogData,
      DocsCountryConfirmationDialogResult
    >(
      DocsCountryConfirmationDialogComponent,
      {
        width: '500px',
        data,
        panelClass: ['tc-dialog', 'modal-md'],
        disableClose: true // Force user to make a choice
      }
    )

    return dialogRef.afterClosed()
  }
}
